/* eslint-disable */
export default {
  callerCall: 'Appelant',
  transferCall: 'Transférer',
} as const;

// @key: @#@"callerCall"@#@ @source: @#@"Caller"@#@
// @key: @#@"transferCall"@#@ @source: @#@"Transfer"@#@
